import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledCard = styled.article(props => {
  const {
    theme: {
      base: { spacing }
    }
  } = props;

  return css`
    margin: calc(2 * ${spacing});
    padding: ${spacing};
    height: max-content;
    width: max-content;
  `;
});

StyledCard.defaultProps = defaultThemeProp;
